import configClient from "../../api/hooks/config-client"

export const apiBaseURL = "/api/"
export const release = configClient.release
